import { render, staticRenderFns } from "./SchedulingGame.vue?vue&type=template&id=0bd7ddd3&scoped=true&"
import script from "./SchedulingGame.vue?vue&type=script&lang=js&"
export * from "./SchedulingGame.vue?vue&type=script&lang=js&"
import style0 from "./SchedulingGame.vue?vue&type=style&index=0&id=0bd7ddd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7ddd3",
  null
  
)

export default component.exports